import { KalturaBaseEntry } from "kaltura-typescript-client/api/types/KalturaBaseEntry";
import { KalturaScheduleEvent } from "kaltura-typescript-client/api/types/KalturaScheduleEvent";
import { WebcastEntry } from "@kaltura/mediaspace-shared-types";
import ServerTimeHelper from "./ServerTimeHelper";
import { postKmsData } from "./fetchData";
import { baseUrl } from "./kms";

/**
 * get entry duration prop value
 * @param entry
 */
export const getDuration = (entry: KalturaBaseEntry | KalturaScheduleEvent): number | undefined => {
    if ("duration" in entry) {
        return entry.duration;
    }
    return undefined;
};

/**
 * check if entry is live
 * @param entry
 */
export const getIsLive = (entry: KalturaBaseEntry | WebcastEntry) => {
    if ("schedulingData" in entry) {
        const serverTime = ServerTimeHelper.getUpdatedTime();
        const startTime = entry.schedulingData.start.timestamp * 1000;
        const endTime = entry.schedulingData.end.timestamp * 1000;
        return !!startTime && !!endTime && serverTime < endTime && serverTime > startTime;
    }
    return false;
};

/**
 * Send request to clear the cache for an entry
 */
export const clearEntryCache = async (entryId: string) => {
    try {
        await postKmsData(baseUrl + `/default/entry/clear-entry-metadata-cache/id/${entryId}`);
    }
    catch (e: unknown) {
        console.warn(`Failed to clear entry cache for ${entryId}:`, e);
    }
};
